import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from '@angular/core';
import { AppState } from 'src/app/root-store/state';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import { selectSearchState, selectPageCount, selectDisplayPages, selectMatchedAnnouncementCount, selectIsExpanded, selectAnnouncements, selectPreviewAnnouncements, selectIsSearchResultLoading, selectSearchResultMetaData, selectSearchPageListtBanner, selectSearchPageLeftBanner, selectSearchPageTopBanner, selectFilterExpanded, selectNextSearchPageQueryParams, selectPreviuseSearchPageQueryParams, selectSearchPageBannerIds } from 'src/app/root-store/announcement-store/search-page/selectors';
import { AnnouncementFilter } from 'src/app/shared/models/announcement-filter';
import { AnnouncementService } from 'src/app/shared/services/announcement.service';
import { Observable, Subscription, combineLatest, filter, fromEvent, take } from 'rxjs';
import { selectSalaryOptions, selectPublishDateOptions, ProviderWebsiteUrlMap, selectCurrentWebsite, selectCurrentUserType } from 'src/app/root-store/selectors';
import { SearchState } from 'src/app/root-store/announcement-store/search-page/state';
import { loadFrontPageAnnouncements } from 'src/app/root-store/announcement-store/announcement-front-page-actions';
import { PageNameEnum } from 'src/app/shared/models/enums/page-names-enum';
import { Announcement } from '../shared/models/announcement-model';
import { loadLastListingPage, sendBannerViewToAnalytic } from 'src/app/root-store/actions';
import { MetaService } from 'src/app/shared/services/meta.service';
import { Banner } from 'src/app/banner/shared/models/banner-model';
import { BannerTargetEnum } from 'src/app/banner/shared/models/enums/banner-target-enum';
import { BannerPositionEnum } from 'src/app/banner/shared/models/enums/banner-position-enum';
import { getSearchPageBannerList, toggleExpandFilter } from 'src/app/root-store/announcement-store/search-page/actions';
import { Breakpoints } from 'src/app/shared/models/breakpoints-model';
import { SsrService } from '@hrra/core';
import { DOCUMENT } from '@angular/common';
import { EnvService, PagingNavItem, RoutablePagingNavItem } from '@hrra/core';
import { OptionItem } from '@hrra/common-models';
import { DeviceDetectionService, Range } from '@hrra/core';
import { BannerHeaderPositionId } from 'src/app/shared/models/enums/banner-header-position-id-enum';
import { OverlayService } from 'primeng/api';

@Component({
    selector: 'app-ann-search',
    templateUrl: './ann-search.component.html',
    styleUrls: ['./ann-search.component.scss'],
    standalone: false
})
export class AnnSearchComponent implements OnInit {

  @ViewChild('searchFilter')
  searchFilter!: any;

  metaDataSubscription: Subscription;

  pageId: any;

  providerWebsiteId: number

  date = new Date();

  targetId: number = BannerTargetEnum.Desktop;
  isDesktop = false;

  constructor(@Inject(DOCUMENT) private _document,
              private store: Store<AppState>, 
              private router: Router, 
              private announcementService: AnnouncementService, 
              private metaService: MetaService,
              private deviceDetectionService: DeviceDetectionService,
              private envService: EnvService,
              private ssr: SsrService) {
                this.pageName = PageNameEnum;
                this.pageId = BannerHeaderPositionId.SearchResultPage
              }

  public search$: Observable<SearchState>;
  
  public isFilterExpanded$: Observable<boolean>;

  public salaryOptions$: Observable<OptionItem<Range<number>>[]>;
  public publishDateOptions$: Observable<OptionItem<Range<number>>[]>;

  public pageCount$: Observable<number>;
  public navItems$: Observable<RoutablePagingNavItem[]>;
  public previousePageQueryParams$: Observable<any>;
  public nextPageQueryParams$: Observable<any>;


  public pageName: any;
  announcements$: Observable<Announcement[]>;
  previewAnnouncements$: Observable<Announcement[]>;
  matchedAnnouncementCount$: Observable<number>;
  filterIsExpanded$: Observable<boolean>;
  providerWebsiteUrlMap$: Observable<{ [index: number]: string }>;

  topBanner$: Observable<Banner>;
  listBanner$: Observable<Banner>;
  leftBanner$: Observable<Banner>;

  isLoading$: Observable<boolean>;

  userType$: Observable<any>;
  
  sidebar: HTMLElement | null = null;
  content: HTMLElement | null = null;
  annInfo: HTMLElement | null = null;
  header: HTMLElement | null = null;

  lastScrollTop = 0;
  sidebarPosition = 'relative';
  sidebarTop = 'relative';
  sidebarBottom = 'relative';

  ngOnInit(): void {
    this.providerWebsiteId = this.envService.tenantId;
    
    const deviceInfo = this.deviceDetectionService.detectDevice();
    this.isDesktop = deviceInfo.isDesktop;
    this.targetId = deviceInfo.isDesktop ? BannerTargetEnum.Desktop : BannerTargetEnum.Responsive;

    let searchPageBanners$ = this.store.select(selectSearchPageBannerIds);
    let providerWebsiteId$ = this.store.select(selectCurrentWebsite);

    combineLatest([searchPageBanners$, providerWebsiteId$])
    .pipe(
      filter(([banners, provderWebsite]) =>{
        return banners.bannerIdList.length > 0 && provderWebsite !== null && provderWebsite !== undefined;
      }),
      take(1)
    )
    .subscribe(
      ([b, p]) => {
        this.store.dispatch(sendBannerViewToAnalytic({payload:{bannerIdList: b, providerWebsiteId:p.providerWebsiteId, pageId: BannerHeaderPositionId.FrontPage}}))
      }
    )

    this.store.dispatch(loadLastListingPage({payload: PageNameEnum.SearchResultsPage}));
    if(this.ssr.isPlatformBrowser()){
      this.store.dispatch(getSearchPageBannerList({payload: {targetId: this.targetId, bannerHeadId: BannerPositionEnum.Search_results}}));
    }

    this.salaryOptions$ = this.store.pipe(select(selectSalaryOptions({ emptyItemName: 'All'})));
    this.publishDateOptions$ = this.store.pipe(select(selectPublishDateOptions));
    this.search$ = this.store.pipe(select(selectSearchState));
    this.pageCount$ = this.store.pipe(select(selectPageCount));
    this.navItems$ = this.store.pipe(select(selectDisplayPages));
    this.nextPageQueryParams$ = this.store.pipe(select(selectNextSearchPageQueryParams));
    this.previousePageQueryParams$ = this.store.pipe(select(selectPreviuseSearchPageQueryParams))


    this.previewAnnouncements$ = this.store.pipe(select(selectPreviewAnnouncements));
    this.announcements$ = this.store.pipe(select(selectAnnouncements));
    this.matchedAnnouncementCount$ = this.store.pipe(select(selectMatchedAnnouncementCount));
    this.filterIsExpanded$ = this.store.pipe(select(selectIsExpanded));
    this.providerWebsiteUrlMap$ = this.store.pipe(select(ProviderWebsiteUrlMap));

    this.topBanner$ = this.store.pipe(select(selectSearchPageTopBanner));
    this.listBanner$ = this.store.pipe(select(selectSearchPageListtBanner));
    this.leftBanner$ = this.store.pipe(select(selectSearchPageLeftBanner));

    //this.store.dispatch(loadFrontPageAnnouncements());
    
    this.isLoading$ = this.store.pipe(select(selectIsSearchResultLoading));

    this.userType$ = this.store.select(selectCurrentUserType);
 
    this.metaDataSubscription = this.store.pipe(select(selectSearchResultMetaData)).subscribe(
      (data) => {
        this.metaService.updateMetaData(data.website, data.metaData);
      }
    )

    this.sidebar = this._document.getElementById('sticky');
    this.content = this._document.getElementById('ann-list');
    this.annInfo = this._document.getElementById('ann-info');
    this.header = this._document.querySelector('header');

  }

  ngOnDestroy() {
    this.metaDataSubscription.unsubscribe();
  }


  @HostListener("window:scroll", ["$event"])
  onScroll() {
    this.closeAllDropdowns();
    this.onScrollAndResize();
  }
  
  @HostListener('window:resize', ['$event'])
  onScrollAndResize() {
    const sideBar = this._document.getElementById("sticky");
    const content = this._document.getElementById("ann-list");
  
    if (!sideBar || !content || window.innerWidth <= Breakpoints.huge) {
      return;
    }
  
    const sidebarTop = this.getSidebarTopOffset();
    const sidebarBottom = 425;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
    const sidebarRect = sideBar.getBoundingClientRect();
    const contentRect = content.getBoundingClientRect();
  
    const scrollToClustersTop = sidebarRect.top <= sidebarTop;
    const scrollToClustersBottom = sidebarRect.top + sideBar.offsetHeight < window.innerHeight;
    const scrollToSerpTop = contentRect.top <= sidebarTop;
    const scrollToSerpBottom = contentRect.top + contentRect.height < window.innerHeight;
  
    const isMovingDown = scrollTop > this.lastScrollTop;
    const isScrolling = Math.abs(scrollTop - this.lastScrollTop) > 10;
  
    if (!isScrolling) return;
  
    if (sideBar.offsetHeight > content.offsetHeight) {
      this.setPosition({ position: 'static' });
      return;
    }
  
    if (contentRect.bottom < window.innerHeight) {
      this.setPosition({ position: 'absolute', bottom: sidebarBottom });
      return;
    }
  
    if (isMovingDown) {
      if (sideBar.offsetHeight < window.innerHeight) {
        if (scrollToSerpBottom) {
          this.setPosition({ position: 'absolute', bottom: sidebarBottom });
          return;
        }
  
        if (scrollToSerpTop) {
          this.setPosition({ position: 'fixed', top: sidebarTop });
          return;
        }
      } else {
        if (this.sidebarPosition === 'absolute' && this.sidebarTop !== 'auto') {
          if (scrollToClustersBottom) {
            this.setPosition({ position: 'fixed', bottom: 0 });
            return;
          }
        }
  
        if (this.sidebarPosition === 'fixed' && Math.round(sidebarRect.top) === sidebarTop) {
          this.setPosition({ position: 'absolute', top: sidebarRect.top - contentRect.top });
        }
  
        if (scrollToClustersTop && sideBar.offsetHeight < window.innerHeight) {
          this.setPosition({ position: 'fixed', top: sidebarTop });
        }
  
        if (scrollToClustersBottom) {
          this.setPosition({ position: 'fixed', bottom: 0 });
        }
  
        if (scrollToSerpBottom) {
          this.setPosition({ position: 'absolute', bottom: sidebarBottom });
        }
      }
    } else {
      if (this.sidebarPosition === 'fixed' && this.sidebarBottom === '0px') {
        this.setPosition({ position: 'absolute', top: sidebarRect.top - contentRect.top });
      }
  
      if (sidebarRect.top > sidebarTop && !scrollToClustersTop) {
        this.setPosition({ position: 'fixed', top: sidebarTop });
      }
  
      if (contentRect.top >= sidebarTop) {
        this.setPosition({ position: 'static' });
      }
    }
  
    this.lastScrollTop = scrollTop;
  }
  
  clickOnSideBar() {
    if (window.innerWidth > Breakpoints.huge) {
      this.onResize();
    }
  }
  
  onResize() {
    const sidebarTop = this.getSidebarTopOffset();
    const sidebarBottom = 425;
  
    const sideBar = this._document.getElementById("sticky");
    const content = this._document.getElementById("ann-list");
  
    if (!sideBar || !content || content.offsetHeight < sideBar.offsetHeight) {
      return;
    }
  
    const contentRect = content.getBoundingClientRect();
    const sidebarRect = sideBar.getBoundingClientRect();
  
    if (contentRect.bottom < window.innerHeight) {
      this.setPosition({ position: 'absolute', bottom: sidebarBottom });
      return;
    }
  
    if (sidebarRect.top + sideBar.offsetHeight < window.innerHeight &&
        window.innerHeight < content.offsetHeight &&
        content.offsetHeight > sideBar.offsetHeight &&
        contentRect.top <= sidebarTop) {
  
      if (contentRect.top + contentRect.height < window.innerHeight) {
        if (sideBar.offsetHeight < window.innerHeight && contentRect.top + contentRect.height > window.innerHeight) {
          this.setPosition({ position: 'fixed', top: sidebarTop });
        } else {
          this.setPosition({ position: 'absolute', bottom: 0 });
        }
      } else if (sideBar.offsetHeight < window.innerHeight &&
                 content.offsetParent.offsetTop < window.scrollY + window.innerHeight) {
        this.setPosition({ position: 'fixed', top: sidebarTop });
      } else {
        this.setPosition({ position: 'fixed', bottom: 0 });
      }
    }
  }
  
  onResizeWindowWidth(filterIsExpanded: boolean) {
    if (this.isDesktop && window.innerWidth < Breakpoints.huge) {
      this.isDesktop = false;
      this.setPosition({ position: 'relative' });
    } else if (!this.isDesktop && window.innerWidth > Breakpoints.huge) {
      this.setPosition({ position: 'relative' });
      this.isDesktop = true;
  
      if (filterIsExpanded) {
        this.store.dispatch(toggleExpandFilter());
      }
    }
  }
  
  private getSidebarTopOffset(): number {
    const header = this._document.getElementsByTagName('header')[0];
    const annInfo = this._document.getElementById('ann-info');
  
    return Math.round(
      parseFloat(getComputedStyle(header).paddingTop) +
      parseFloat(getComputedStyle(header).paddingBottom) +
      parseFloat(getComputedStyle(header).height) +
      parseFloat(getComputedStyle(annInfo).height)
    );
  }
  
  private closeAllDropdowns() {
    this.safeClose(() => this.searchFilter.tree.closeDropdown());
    this.safeClose(() => this.searchFilter.publishDateDropdown.hide());
    this.safeClose(() => this.searchFilter.transportTypeMultiSelect.hide());
    this.safeClose(() => this.searchFilter.workScheduleMultiSelect.hide());
    this.safeClose(() => this.searchFilter.seniorityLevelMultiSelect.hide());
    this.safeClose(() => this.searchFilter.locationTreeSelect.treeSelect.hide());
    this.safeClose(() => this.searchFilter.specializationTreeSelect.treeSelect.hide());
    this.safeClose(() => this.searchFilter.industryTreeSelect.treeSelect.hide());
    this.safeClose(() => this.searchFilter.announcementTypeDropdown.dropdown.hide());
    this.safeClose(() => this.searchFilter.salaryDropdown.dropdown.hide());
  }
  
  private safeClose(action: () => void) {
    try {
      action();
    } catch {
      // Ignore errors when components are not initialized yet.
    }
  }
  
  private setPosition({ position, top, bottom }: { position: string; top?: number; bottom?: number }) {
    this.sidebarPosition = position;
    this.sidebarTop = top !== undefined ? `${top}px` : 'auto';
    this.sidebarBottom = bottom !== undefined ? `${bottom}px` : 'auto';
  }
  


}
  

// enum AnnouncementFilterQueryParams{
//   AnnouncementType='t',
//   Categories='c',
//   Experience='e',
//   Locality='l',
//   PublishDate='p',
//   Query='q',
//   Salary='s'
// }